module.exports = __webpack_public_path__ + "img/ico_home-accent.ac81948c.svg";